import React, { createContext, useContext, useEffect, useState } from "react";
import { api, saveAuth, clearAuth, getStoredUser } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const token = localStorage.getItem("vg2_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        if (!cancelled) {
          setUser(r.data);
          localStorage.setItem("vg2_user", JSON.stringify(r.data));
        }
      })
      .catch(() => {
        if (!cancelled) {
          clearAuth();
          setUser(null);
        }
      })
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  const login = async (email, password, remember_me) => {
    const r = await api.post("/auth/login", { email, password, remember_me });
    saveAuth(r.data.token, r.data.user);
    setUser(r.data.user);
    return r.data.user;
  };
  const signup = async (payload) => {
    const r = await api.post("/auth/signup", payload);
    saveAuth(r.data.token, r.data.user);
    setUser(r.data.user);
    return r.data;
  };
  const signupOwner = async (payload) => {
    // OwnerDesk V1 · lightweight signup (no Stripe/no referral). If the
    // caller has a cached anon token, forward it so cases created during
    // the anon session are re-linked to the new owner on the server.
    const anonToken = localStorage.getItem("vg2_anon_token");
    const headers = anonToken ? { "X-VG2-Anon-Token": anonToken } : {};
    const r = await api.post("/auth/owner/signup", payload, { headers });
    saveAuth(r.data.token, r.data.user);
    setUser(r.data.user);
    return r.data;
  };
  const logout = () => {
    clearAuth();
    setUser(null);
  };
  const refresh = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    localStorage.setItem("vg2_user", JSON.stringify(r.data));
    return r.data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, signupOwner, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
